import { useId, useState } from 'react'
import { createPortal } from 'react-dom'

/** A field-local explanation, rendered outside clipping card containers. */
export function RecalculationNote({ label, explanation }: { label: string; explanation: string }) {
  const id = useId()
  const [position, setPosition] = useState<{ top: number; left: number } | null>(null)
  const [pinned, setPinned] = useState(false)
  return <>
    <button type="button" aria-label={`Why ${label} was recalculated`} aria-describedby={position ? id : undefined}
      aria-expanded={Boolean(position)}
      className="inline-flex shrink-0 items-center px-1 text-sm font-semibold text-amber-300 focus-visible:outline focus-visible:outline-amber-300"
      onMouseEnter={event => { const rect = event.currentTarget.getBoundingClientRect(); setPosition({ top: Math.max(8, rect.top - 90), left: Math.max(8, Math.min(rect.left, window.innerWidth - 296)) }) }}
      onMouseLeave={() => { if (!pinned) setPosition(null) }}
      onFocus={event => { const rect = event.currentTarget.getBoundingClientRect(); setPosition({ top: Math.max(8, rect.top - 90), left: Math.max(8, Math.min(rect.left, window.innerWidth - 296)) }) }}
      onBlur={() => { setPinned(false); setPosition(null) }}
      onClick={event => { event.stopPropagation(); const rect = event.currentTarget.getBoundingClientRect(); setPinned(!pinned); setPosition(pinned ? null : { top: Math.max(8, rect.top - 90), left: Math.max(8, Math.min(rect.left, window.innerWidth - 296)) }) }}
      onKeyDown={event => { if (event.key === 'Escape') { setPinned(false); setPosition(null) } }}>*</button>
    {position && createPortal(<div id={id} role="tooltip" style={{ position: 'fixed', ...position, zIndex: 10000, width: 280 }} className="rounded border border-amber-300/25 bg-[#11100d] p-3 text-xs text-stone-200 shadow-xl">
      <div className="mb-1 font-medium text-amber-200">{label} recalculated</div>
      <div>{explanation}</div>
    </div>, document.body)}
  </>
}
